import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { CurrencyInput } from '@cash-design-system/react'
import { CurrencyCode } from '@cash-web/protos/squareup/common/currency_codes.pb'
import { FormBlockerElementMoneyInputElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { formatMoney, GenericMoneyInput, getCurrencyPrefix } from '@cash-web/shared-feature-common'
import { FieldErrorText, FormInput } from '@cash-web/shared-feature-form'

import { FormBlockerAdditionalElementProps } from '../FormBlockerElement/FormBlockerElement'

export type MoneyInputElementProps = FormBlockerAdditionalElementProps & FormBlockerElementMoneyInputElement

export const MoneyInputElement = ({
  elementId,
  formSectionIndex,
  shouldAutoFocus,

  // props below from FormBlockerElementMoneyInputElement
  disable_decimal,
  currency_code,
  hint_text,
  is_optional,
  maximum_amount,
  minimum_amount,
  prefill_amount,
}: MoneyInputElementProps) => {
  const { t } = useTranslation()

  const currencyCode = currency_code || CurrencyCode.USD
  const currencyPrefix = getCurrencyPrefix(currencyCode)

  const maximumAmount = maximum_amount?.amount
  const minimumAmount = minimum_amount?.amount
  const prefillAmount = prefill_amount?.amount
    ? formatMoney({
        amount: prefill_amount?.amount,
        currency_code: currencyCode,
      })
    : ''
  const [formattedValue, setFormattedValue] = useState(prefillAmount)
  const formFieldName = `${formSectionIndex}.money_input_result.amount.amount`

  return (
    <>
      <GenericMoneyInput
        ariaLabel={t('Amount in {CURRENCY}', { context: 'The label for a money input', CURRENCY: currency_code })}
        currencyPrefix={currencyPrefix}
        customInput={CurrencyInput}
        data-testid={elementId}
        defaultValue={prefillAmount}
        forceDecimalPoint={!disable_decimal}
        decimalScale={disable_decimal ? 0 : undefined}
        formattedValue={formattedValue}
        isRequired={!is_optional}
        maximumAmount={maximumAmount}
        minimumAmount={minimumAmount}
        name={formFieldName}
        placeholder={hint_text}
        setFormattedValue={setFormattedValue}
        shouldAutoFocus={shouldAutoFocus}
      />
      <FormInput
        name={`${formSectionIndex}.money_input_result.amount.currency_code`}
        defaultValue={currency_code}
        type="hidden"
      />
      <FieldErrorText name={formFieldName} />
    </>
  )
}
